import axios from 'axios';
import { baseAPI } from '../config';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

/**
 * Get Gmail connection and watch status
 * @returns {Promise<Object>} { connection, watch }
 */
export const getGmailStatus = async () => {
  try {
    const response = await axios.get(`${baseAPI}/settings/gmail/status`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error getting Gmail status:', error);
    throw error;
  }
};

/**
 * Get Google OAuth authorization URL
 * @returns {Promise<Object>} { authUrl }
 */
export const getGmailAuthUrl = async () => {
  try {
    const response = await axios.get(`${baseAPI}/settings/gmail/authorize`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error getting Gmail auth URL:', error);
    throw error;
  }
};

/**
 * Disconnect Gmail (revoke tokens)
 * @returns {Promise<Object>}
 */
export const disconnectGmail = async () => {
  try {
    const response = await axios.post(
      `${baseAPI}/settings/gmail/disconnect`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error disconnecting Gmail:', error);
    throw error;
  }
};

/**
 * Setup or renew Gmail Pub/Sub watch
 * @returns {Promise<Object>}
 */
export const renewGmailWatch = async () => {
  try {
    const response = await axios.post(
      `${baseAPI}/settings/gmail/watch`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error renewing Gmail watch:', error);
    throw error;
  }
};
